export const POS_URL = process.env.REACT_APP_POS_URL;